import { render, staticRenderFns } from "./InfoMessageAlerts.vue?vue&type=template&id=490c4d2d"
import script from "./InfoMessageAlerts.vue?vue&type=script&lang=js"
export * from "./InfoMessageAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports